export const statusMapping: { [key: string]: { columnAccessor: string; message: string } } = {
  Queued: { columnAccessor: 'queued', message: 'Success' },
  'Downloaded Successfully': { columnAccessor: 'downloaded', message: 'Success' },
  'Initial Download Failed': { columnAccessor: 'downloaded', message: 'Failed' },
  'Flashed Successfully': { columnAccessor: 'flashed', message: 'Success' },
  'Flash Failed': { columnAccessor: 'flashed', message: 'Failed' },
  'Auto Retry 1 Failed': { columnAccessor: 'autoRetryFailed1', message: 'Success' },
  'Auto Retry 2 Failed': { columnAccessor: 'autoRetryFailed2', message: 'Success' },
  'Firmware Reported': { columnAccessor: 'reportedSoftware', message: 'Success' },
  'Removed Due to inactivity': {columnAccessor: 'inactivity', message: 'Success'},
};
